var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "246px",
    height: "400px",
    viewBox: "0 0 246 400",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.34397 0C10.2574 2.55266 14.5872 7.45359 16.6286 14.3636C16.805 14.9898 16.5184 15.8248 16.245 16.4771C15.4955 18.3209 14.089 18.8384 12.4444 17.686C7.44444 14.1375 2.72229 10.2454 0.0988735 4.59218C-0.333218 3.65722 0.75142 1.91776 1.41279 0.687087C1.64206 0.247873 2.6782 0.217433 3.34397 0",
    transform: "matrix(1.1924881E-08 1 -1 1.1924881E-08 138.48242 382.5558)",
    id: "Fill-245",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6829 19.4185C23.9396 20.704 23.2292 22.6865 22.7555 22.6091C14.8094 21.3003 7.15262 18.7989 1.62714 11.4109C0.344438 9.70722 -0.359403 6.26104 0.186567 4.15462C0.673336 2.30375 3.39003 -0.189887 4.90296 0.0114628C15.0067 1.38219 20.7624 9.2658 24.6829 19.4185",
    transform: "matrix(0.9659258 -0.25881904 0.25881904 0.9659258 0 195.47034)",
    id: "Fill-247",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5708 10.7418C13.1586 11.4111 12.8758 12.4732 12.2959 12.672C10.882 13.1619 9.09906 13.8845 7.85771 13.4238C3.76941 11.9154 0.888902 8.86485 0.030981 4.48054C-0.203869 3.27777 0.946416 1.64335 1.79475 0.445422C2.10149 -0.000769131 3.66876 -0.165666 4.12887 0.202927C7.27778 2.78793 10.3356 5.48932 13.2832 8.29742C13.7433 8.72906 13.4941 9.90758 13.5708 10.7418",
    transform: "translate(102.01196 5.3828125)",
    id: "Fill-261",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.145 247.705C289.824 247.705 364.145 173.385 364.145 81.7053C364.145 22.7713 238.756 -13.9163 141.318 5.00845C87.1795 15.5236 79.6783 62.1301 35.346 80.989C-2.39396 97.0435 -15.6526 158.795 24.3594 201.14C67.4023 246.691 150.632 247.705 198.145 247.705Z",
    transform: "matrix(0.9659258 -0.25881904 0.25881904 0.9659258 84.52417 94.24762)",
    id: "Oval",
    fill: "#ADDCE1",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg103);
export default __webpack_public_path__ + "static/media/103.3493f3c5507962c02cb25ca759e25b85.svg";
export { ForwardRef as ReactComponent };